import { IconComponent } from './types';

const PlugIcon: IconComponent = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.17334 2.66792L8.17459 3.17173L8.67838 3.16664C8.84239 3.16498 9.05147 3.25191 9.23061 3.43105C9.40944 3.60988 9.5 3.82243 9.5 3.99333V7.45331L7.31261 9.64695L7.16667 9.79331V10V11.5H4.83333V10V9.79373L4.68789 9.64746L2.5 7.44706V3.99333C2.5 3.82243 2.59056 3.60988 2.76939 3.43105C2.94853 3.25191 3.15761 3.16498 3.32162 3.16664L3.32162 3.16667H3.32667H3.33333H3.83333V2.66667V0.5H4.16667V2.66667V3.16667H4.66667H7.33333H7.83333V2.66667V0.5H8.16792L8.17334 2.66792Z"
      stroke="currentColor"
    />
  </svg>
);

export default PlugIcon;
